export const movieInfo = {
  title: "色戒",
  englishTitle: "Lust, Caution",
  slogan: "乱世之中，爱与信念皆有代价",
  year: "2007",
  duration: "158 分钟",
  region: "中国 / 美国",
  language: "普通话 / 粤语",
  director: "李安",
  screenwriter: "王蕙玲 / 詹姆士·夏姆斯",
  cast: "梁朝伟 / 汤唯 / 陈冲 / 王力宏 / 庹宗华",
  genre: "剧情 / 爱情 / 惊悚",
  rating: 8.6,
  ratingCount: "42.8 万人评价",
  summary:
    "上世纪四十年代的动荡岁月里，一群热血青年密谋一场关乎信念的行动，而一段在克制与沉沦之间摇摆的情感，最终将所有人推向无法回头的命运深处。影片以细腻而克制的镜头语言，书写了乱世中人性、欲望与牺牲的复杂图景。",
  tags: ["经典佳作", "情感张力", "时代群像", "金奖导演"],
  awards: [
    "威尼斯电影节 最佳影片（金狮奖）",
    "台湾金马奖 最佳剧情片 / 最佳导演",
    "亚洲电影大奖 多项提名",
    "年度最佳华语影片评选 榜首",
  ],
  facts: [
    { label: "导演", value: "李安" },
    { label: "上映年份", value: "2007 年" },
    { label: "片长", value: "158 分钟" },
    { label: "类型", value: "剧情 / 爱情" },
    { label: "制片地区", value: "中国 / 美国" },
    { label: "对白语言", value: "普通话 / 粤语" },
  ],
};

export const movieStillImages = [
  "https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20still%20of%20a%201930s%20Shanghai%20vintage%20street%20at%20dusk%2C%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20dramatic%20chiaroscuro%2C%20rain-wet%20cobblestones%2C%20elegant%20atmospheric%20period%20atmosphere%2C%20no%20text&width=1200&height=800&seq=story-still-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20elegant%20vintage%20interior%20with%20a%20red%20velvet%20curtain%20and%20warm%20lamp%20glow%2C%20deep%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20moody%20romantic%20period%20atmosphere%2C%20no%20text&width=1200&height=800&seq=story-still-02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20majestic%20old%20Shanghai%20mansion%20staircase%20with%20dim%20golden%20light%2C%20deep%20red%20accents%2C%20dramatic%20shadows%2C%20nostalgic%20period%20drama%20mood%2C%20no%20text&width=1200&height=800&seq=story-still-03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20rain%20falling%20on%20a%20vintage%20window%20with%20warm%20interior%20light%2C%20crimson%20and%20amber%20tones%2C%20moody%20melancholic%20period%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=1200&height=800&seq=story-still-04&orientation=landscape",
];

export const heroSlides = [
  {
    seq: "hero-slide-01",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20dramatic%20portrait%20of%20a%201930s%20Shanghai%20street%20scene%20with%20deep%20crimson%20and%20amber%20lighting%2C%20rain-wet%20cobblestones%2C%20moody%20chiaroscuro%2C%20vintage%20period%20atmosphere%2C%20elegant%20and%20mysterious%2C%20no%20text&width=1920&height=1080&seq=hero-slide-01&orientation=landscape",
    tag: "本站首播",
    title: "色戒",
    subtitle: "乱世之中，爱与信念皆有代价",
  },
  {
    seq: "hero-slide-02",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20empty%20old%20movie%20theater%20with%20red%20velvet%20seats%20and%20glowing%20screen%20beams%2C%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20moody%20atmospheric%2C%20vintage%20cinema%20nostalgia%2C%20no%20text&width=1920&height=1080&seq=hero-slide-02&orientation=landscape",
    tag: "深度解析",
    title: "剧情背后的时代群像",
    subtitle: "从人物命运读懂那个风起云涌的年代",
  },
  {
    seq: "hero-slide-03",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20abstract%20portrait%20silhouette%20against%20red%20curtain%20with%20warm%20golden%20rim%20light%2C%20deep%20crimson%20tones%2C%20dramatic%20theatrical%20lighting%2C%20elegant%20mysterious%20period%20mood%2C%20no%20text&width=1920&height=1080&seq=hero-slide-03&orientation=landscape",
    tag: "影迷精选",
    title: "影评与专题合集",
    subtitle: "百余篇深度影评，读懂镜头里的每一处留白",
  },
];

export const featuredReviews = [
  {
    id: "r-001",
    title: "克制之下的暗涌：谈《色戒》的表演美学",
    author: "影迷·林深",
    date: "2026-09-28",
    rating: 9.2,
    excerpt:
      "真正动人的表演，从来不是声嘶力竭。影片中大量沉默的注视与欲言又止，构成了最锋利的情感刀锋。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20close-up%20texture%20of%20red%20silk%20fabric%20with%20warm%20golden%20light%2C%20elegant%20abstract%20film%20still%20mood%2C%20deep%20crimson%20tones%2C%20no%20text&width=800&height=600&seq=review-cover-01&orientation=landscape",
    tags: ["表演解析", "深度长评"],
  },
  {
    id: "r-002",
    title: "光影里的时代：评影片的镜头语言与美术",
    author: "影评人·陈默",
    date: "2026-09-21",
    rating: 8.9,
    excerpt:
      "一窗、一帘、一盏灯，都被赋予了叙事的重量。美术与摄影共同搭建起一个既真实又超验的情感空间。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20dim%20elegant%20room%20with%20window%20light%20and%20red%20curtain%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20dramatic%20moody%20atmosphere%2C%20no%20text&width=800&height=600&seq=review-cover-02&orientation=landscape",
    tags: ["摄影美术", "深度长评"],
  },
  {
    id: "r-003",
    title: "选择的重量：人物命运与主题解读",
    author: "影迷·苏晚",
    date: "2026-09-12",
    rating: 9.5,
    excerpt:
      "每个人都在自己的信念与情感之间艰难权衡。影片没有给出答案，却让观众在离场后久久无法平静。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20symbolic%20film%20still%20of%20a%20lone%20figure%20silhouette%20walking%20in%20a%20dim%20corridor%20with%20red%20glow%2C%20dramatic%20chiaroscuro%20lighting%2C%20moody%20period%20drama%2C%20no%20text&width=800&height=600&seq=review-cover-03&orientation=landscape",
    tags: ["主题解读", "观众视角"],
  },
];

export const recommendedMovies = [
  {
    id: "m-001",
    title: "旗袍",
    year: "2019",
    genre: "剧情 / 时代",
    rating: 8.1,
    duration: "124 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=minimalist%20vintage%20movie%20poster%20inspired%20composition%20of%20a%20red%20qipao%20dress%20detail%20on%20dark%20background%2C%20deep%20crimson%20and%20gold%20tones%2C%20elegant%20cinematic%20period%20style%2C%20no%20text&width=600&height=900&seq=movie-poster-01&orientation=portrait",
  },
  {
    id: "m-002",
    title: "暗涌",
    year: "2021",
    genre: "悬疑 / 剧情",
    rating: 7.8,
    duration: "110 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=minimalist%20moody%20movie%20poster%20composition%20of%20rain%20on%20dark%20glass%20with%20amber%20lamplight%20reflection%2C%20noir%20cinematic%20style%2C%20deep%20red%20accents%2C%20no%20text&width=600&height=900&seq=movie-poster-02&orientation=portrait",
  },
  {
    id: "m-003",
    title: "旧梦",
    year: "2018",
    genre: "爱情 / 文艺",
    rating: 8.3,
    duration: "132 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=minimalist%20romantic%20movie%20poster%20composition%20of%20a%20vintage%20gramophone%20and%20warm%20lamp%20on%20dark%20background%2C%20crimson%20and%20amber%20tones%2C%20elegant%20nostalgic%20period%20style%2C%20no%20text&width=600&height=900&seq=movie-poster-03&orientation=portrait",
  },
  {
    id: "m-004",
    title: "红唇",
    year: "2020",
    genre: "剧情 / 犯罪",
    rating: 7.6,
    duration: "118 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=minimalist%20noir%20movie%20poster%20composition%20of%20a%20red%20lipstick%20and%20mirror%20with%20dim%20light%2C%20deep%20crimson%20and%20silver%20tones%2C%20dramatic%20elegant%20style%2C%20no%20text&width=600&height=900&seq=movie-poster-04&orientation=portrait",
  },
  {
    id: "m-005",
    title: "夜上海",
    year: "2022",
    genre: "剧情 / 音乐",
    rating: 8.0,
    duration: "126 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=minimalist%20vintage%20movie%20poster%20composition%20of%20a%20neon%20sign%20and%20rain%20on%20night%20street%2C%20warm%20amber%20and%20red%20glow%2C%20elegant%20nostalgic%20Shanghai%20style%2C%20no%20text&width=600&height=900&seq=movie-poster-05&orientation=portrait",
  },
  {
    id: "m-006",
    title: "迷岸",
    year: "2023",
    genre: "剧情 / 爱情",
    rating: 7.9,
    duration: "115 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=minimalist%20movie%20poster%20composition%20of%20a%20lone%20boat%20on%20misty%20dark%20water%20with%20amber%20horizon%20glow%2C%20moody%20cinematic%20style%2C%20deep%20crimson%20accent%2C%20no%20text&width=600&height=900&seq=movie-poster-06&orientation=portrait",
  },
];